module.exports = __webpack_public_path__ + "media/images/about/time/7-5888303356324932cb21343c82f91975.png";